import { V1Photo } from './photo'
import { Icon } from './kit'
import { C } from './style'
import { tr } from './text'

/**
 * A compact live reading-photo row (scale display, moisture meter …). The photo is kept on the
 * phone and uploaded by sync before the delivery command.
 */
export function OptionalPhoto({
  value,
  onChange,
  label,
  takenLabel,
  retakeLabel,
  required = false,
}: {
  value: string | null
  onChange: (id: string | null) => void
  label: string
  takenLabel: string
  retakeLabel: string
  required?: boolean
}) {
  return (
    <V1Photo
      value={value}
      onChange={onChange}
      render={({ preview, busy, take }) => (
        <button
          type="button"
          onClick={take}
          disabled={busy}
          aria-label={value ? retakeLabel : label}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            minHeight: 48,
            flexShrink: 0,
            padding: '4px 10px',
            borderRadius: 10,
            border: `2px ${value ? 'solid' : 'dashed'} ${value ? C.ok : C.rule}`,
            background: C.surface,
            color: C.ink,
            fontSize: 16,
            fontWeight: 600,
            textAlign: 'left',
          }}
        >
          {preview ? (
            <img
              src={preview}
              alt=""
              style={{ width: 40, height: 40, borderRadius: 6, objectFit: 'cover' }}
            />
          ) : (
            <Icon name="camera" size={24} />
          )}
          <span style={{ flex: 1 }}>
            {value ? takenLabel : label}
            {!value && (
              <span style={{ color: C.muted, fontWeight: 500 }}>
                {' '}
                · {tr(required ? 'common.required' : 'gate.v1.weigh.optional')}
              </span>
            )}
          </span>
        </button>
      )}
    />
  )
}
